<template>
  <div class="news1-box">
    <div class="bgPic">
      <div class="picText">
        <span class="title">数字化运营服务商，全渠道数字化信息平台</span><br>
        <span>为企业提供专业、高效的服务</span>
      </div>
      <!-- <div class="pic">
        <img
          src="@/assets/last/bg/新闻资讯banner.png"
          alt=""
          style="height: 870px; width: 100%"
        />
      </div> -->
    </div>
    <!--  -->
    <div class="box">
            <p><el-button type="text" @click="goNews(0)">新闻动态</el-button> ><el-button type="text">动态详情</el-button>  </p>

      <div class="card" id="card">
        <el-card class="box-card">
          <div slot="header" class="title">
            <p>AICM智能会员管理系统全新升级</p>
            <span class="time">发布时间：2022-05-16</span>
            <span>量：{{ number }}</span>
          </div>
          <div class="content">
            <p>
              AICM智能会员管理系统全新升级，通过与企业微信多维度联结，任务体系搭建终端门店店长、导购赋能，同步
              标签体系，让用户实现精准营销，智能推荐。
            </p>
            <div class="imgs">
              <img src="@/assets/last/certificate/AICM智能会员管理系统.png" alt="" />
            </div>
            <p>AICM2.0本次升级内容：</p>
            <ul>
              <li>*支持实体店铺企业微信邀约推广体系;</li>
              <li>*支持公众号会员服务体系与H5会员中心注册权益服务体系;</li>
              <li>*支持高价值人群任务回访;</li>
              <li>*支持企业微信好友关系标签及用户分组;</li>
              <li>*提供导购、渠道、群活动等高效、个性化引流工具;</li>
              <li>*实现订单板块MA营销任务自动化;</li>
              <li>*实现企微侧边栏丰富客户详情、标签、知识库、文件库、智慧推荐等功能;</li>
              <li>*支持导购企业微信推荐订单成交标识体系基础建设;</li>
            </ul>
          </div>
        </el-card>
      </div>
      <div class="link">
        <div class="left">
            <span>上一篇： </span>
        <el-button type="text" @click="goNews(1)">泽润软件获信息安全管理标准认证</el-button>
        </div>
        <div class="right">
            <span>下一篇： </span>
        <el-button type="text" @click="goNews(3)"
          >数字化运营方案服务商：高人效智能客服管理方案</el-button
        >
        </div>
        <!-- <a >AICM智能会员管理系统全新升级</a> -->
      </div>
    </div>
    <!-- <div class="footer" ></div> -->
      <BottomFooter />

  </div>
</template>

<script>
import BottomFooter from '../bottom.vue'
export default {
  name: "DemoNews2",
  components: {
    BottomFooter
  },
  data() {
    return {
      number: 1052,
    };
  },
  created() {this.number += 1;this.getScoll()},

  mounted() {
    this.number += 1;
  },

  methods: {
    goNews(type) {
      this.$emit("toggle", type);
    },
     // 滚动
     getScoll(point){
      this.$nextTick(() => {
        // 获取元素
        const scrollTop = document.getElementById('card').offsetTop // 获取需要滚动的距离
        // 元素自身高度
        // const height = document.getElementById(point).offsetHeight
        document.documentElement.scrollTop = scrollTop+600
      })
      
    }
  },
};
</script>

<style lang="less" scoped>
.news1-box {
  .bgPic{
         background: url("../../assets/last/bg/优秀案例背景.png") no-repeat;
    background-size: cover;
    height: 870px;
    }
  .picText {
    color: rgb(242, 243, 247);
    text-align: center;
    letter-spacing: 3px;
    line-height: 80px;
    font-family: SourceHanSansCN-Regular-;
    padding-top: 300px;
    .title {
      display: inline-block;
      font-size: 60px;
      font-weight: normal;
      letter-spacing: 7px;
    }

    span {
      font-size: 40px;
    }
    :hover{
      color: rgba(110, 87, 229);
    }
  }
  .box {
    position: relative;
    text-align: left;
    width: 60%;
    margin: 100px auto;
   line-height: 36px;
        font-size: 20px;
.el-button--text {
  font-size: 20px;
 color: #5b5b5b;

}
    .title {
      font-size: 18px;
      color: #5b5b5b;
      p {
        font-size: 30px;
        color: #333333;
      }
      .time {
        display: inline-block;
        padding-right: 60px;
      }
    }
    .content {
        padding: 0 30px;

      padding-bottom:50px;

      p {
        letter-spacing:1px;
        word-spacing:　2px;
        line-height:1.7;
        text-align:　justify;
        text-indent: 2em;
      }
      .imgs {
        margin: auto;
        text-align: center;
      }
      ul li{
        text-align:left;
        list-style-type:none
      }
    }
    .link {
      padding: 50px 0 0;
      display: flex;
      justify-content: space-between;
      span{
        font-size: 18px;
      }
      .el-button--text {
  font-size: 20px;
 color: rgb(73, 151, 237);

}
    }
  }
  
}

//   .footer{
//     background: url("../../assets/last/bg/底部.png") no-repeat;
//     background-size: contain;
//     height: 550px;
//   }
</style>